<app-dropdown
    [id]="'event-persona-menu-desktop-' + persona().id"
    [dropdownOptions]="personaMenuOptions()"
    [heightInPX]="personaMenuDropdownHeight()"
    [disableDropdown]="readonly()"
    [dropdownListXPosition]="'left'"
    [dropdownListYPosition]="'bottom'"
    (dropdownOpened)="onDropdownOpened()"
    (dropdownClosed)="onDropdownClosed()"
    (optionClicked)="optionClicked.emit($event)"
>
    <button [class.!tw-cursor-not-allowed]="readonly()" type="button" class="tw-group tw-flex tw-items-center tw-flex-col tw-w-full xl:tw-w-[102px]" aria-label="Persona options">
        <div class="tw-h-[72px] tw-w-full tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-flex tw-flex-col hover:tw-border-blue-600" [ngClass]="{ '!tw-border-blue-600': isDropdownOpen() }">
            <div class="tw-bg-blue-50 tw-h-5 tw-flex tw-items-center tw-justify-center tw-rounded-t-lg group-hover:tw-bg-blue-200 tw-transition-colors tw-duration-150" [ngClass]="{ '!tw-bg-blue-200': isDropdownOpen() }">
                <span>
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="4" cy="4" r="3.40278" transform="matrix(1 0 0 -1 0 8)" fill="white" stroke="#1C64F2" stroke-width="1.19444"/>
                    </svg>
                </span>
            </div>
            <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-2 tw-bg-white group-hover:tw-bg-gray-100 tw-transition-colors tw-duration-150 tw-rounded-b-lg" [ngClass]="{ '!tw-bg-gray-100': isDropdownOpen() }">
                <h1
                    #personaNameRef
                    class="tw-font-medium tw-text-xs tw-text-gray-700 tw-font-inter tw-uppercase tw-text-center tw-overflow-hidden tw-leading-4 tw-w-full tw-break-words"
                    style="line-clamp: 2; -webkit-line-clamp: 2; -webkit-box-orient: vertical; display: -webkit-box; max-height: 2rem;"
                    [ngxTippy]="isNameTruncated() ? persona().name : null"
                    [tippyProps]="{ maxWidth: 280 }"
                >
                    {{ persona().name }}
                </h1>
            </div>
        </div>
        <div class="tw--mt-1 tw-bg-white tw-border tw-border-gray-200 tw-rounded-md tw-px-5 tw-py-1 tw-flex tw-items-center tw-justify-center tw-w-[58px] tw-self-center hover:tw-border-blue-600" [ngClass]="{ '!tw-border-blue-600': isDropdownOpen() }" (click)="onRegistrationCountClick($event)">
            <span class="tw-text-blue-600 tw-font-inter tw-font-medium tw-text-xs">{{ formatRegistrationCount() }}</span>
        </div>
    </button>
</app-dropdown>